<template>
  <details :open="expanded ?? chars <= 2000" class="structured-output">
    <summary class="small fw-semibold">
      {{ label }}
      <span class="text-muted fw-normal"
        >· {{ chars.toLocaleString() }} chars</span
      >
    </summary>
    <pre
      class="border rounded bg-body p-3 my-2"
    ><code><span v-for="(token, index) in tokens" :key="index" :class="token.kind">{{ token.value }}</span></code></pre>
  </details>
</template>
<script setup lang="ts">
import { computed } from "vue";
const props = withDefaults(
  defineProps<{
    value: unknown;
    chars: number;
    label?: string;
    expanded?: boolean;
  }>(),
  { label: "Structured output", expanded: undefined }
);
const tokens = computed(() =>
  (JSON.stringify(props.value, null, 2) ?? "null")
    .split(
      /("(?:\\.|[^"\\])*"\s*:|"(?:\\.|[^"\\])*"|\b(?:true|false|null)\b|-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)/g
    )
    .map((value) => ({
      value,
      kind: value.startsWith('"')
        ? value.trimEnd().endsWith(":")
          ? "json-key"
          : "json-string"
        : /^(true|false|null)$/.test(value)
          ? "json-literal"
          : /^-?\d/.test(value)
            ? "json-number"
            : undefined,
    }))
);
</script>
<style scoped lang="scss">
summary {
  cursor: pointer;
  color: var(--phoenix-primary, #1f4d33);
}
pre {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  max-height: 30rem;
  overflow: auto;
  font-size: 0.78rem;
}
.json-key {
  color: var(--phoenix-body-color);
}
.json-string {
  color: var(--phoenix-success-text-emphasis, #1f4d33);
}
.json-number {
  color: var(--phoenix-info-text-emphasis, #07567a);
}
.json-literal {
  color: var(--phoenix-secondary-color);
}
</style>
